module.exports = __webpack_public_path__ + "../static/img/va_logo.354fedec.png";